import { render } from "./tab.vue?vue&type=template&id=c212eb12&lang=pug"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
script.render = render

export default script